import { gql } from '@apollo/client'

/**
 * Adds a market to a multi-market project. A market is a Survey created under
 * the project (`createSurvey`); its country/language and target completes are
 * then set via `createFieldworkV2`. The market shares the project's master
 * questionnaire — per-market overrides are stored later as augmentations keyed
 * by surveyId (see cin-questionnaire MutationScope.PerCountry), so no separate
 * questionnaire is created here.
 */
export const CREATE_SURVEY = gql`
  mutation createSurvey($name: String!, $projectId: ID!, $waveId: ID) {
    createSurvey(name: $name, projectId: $projectId, waveId: $waveId) {
      surveyId
      name
      nickname
      state
      fieldworkDates {
        startDate
        endDate
      }
      createdDate
      sinceDate
    }
  }
`

export const REMOVE_SURVEY_FROM_PROJECT = gql`
  mutation removeSurveyFromProject($surveyId: ID!, $projectId: ID!) {
    removeSurveyFromProject(surveyId: $surveyId, projectId: $projectId) {
      projectId
    }
  }
`

/**
 * Kept here (untyped `gql`, outside graphql.config.yml's dashboard documents)
 * because `renameSurvey` is not deployed yet and codegen would fail on it —
 * move it to the typed Project.mutations.ts once it is.
 *
 * Narrow selection on purpose: the cache update patches `name` only, so there
 * is no partial Survey to splice over the cached one.
 */
export const RENAME_SURVEY = gql`
  mutation renameSurvey($surveyId: ID!, $name: String!) {
    renameSurvey(surveyId: $surveyId, name: $name) {
      surveyId
      name
    }
  }
`
